module.exports = __webpack_public_path__ + "31d4d8c737dcc379c6fed62471784db9.svg";